import { createContext } from 'react'

const ImageVersioningContext = createContext({
  version: '',
  getUrlWithVersion: () => {},
})

export default ImageVersioningContext
